import { ModalContainer } from 'src/components/ModalContainer';
import { useGlobalStore } from 'src/store';
import { Modals, useModalMethods, useModalState } from 'src/store/modals';
import { AddSiteStep } from './add-site-step';

export const AddSiteModal = () => {
  const selectedPartnerId = useGlobalStore.use.selectedPartnerId();

  const { isOpened, modalProps } = useModalState(Modals.AddSiteModal);
  const { closeModal } = useModalMethods(Modals.AddSiteModal);

  const { address, client, filters, limit, sort, offset, onSuccessSubmit } = modalProps ?? {};

  const partnerId =
    address?.partnerId ?? modalProps?.partnerId ?? client?.partnerId ?? selectedPartnerId;

  return (
    <ModalContainer open={isOpened} onClose={closeModal}>
      <AddSiteStep
        partnerId={partnerId}
        address={address}
        client={client}
        cacheOptions={{ filters, limit, sort, offset }}
        onSaving={closeModal}
        onSaved={onSuccessSubmit}
      />
    </ModalContainer>
  );
};
